export default __webpack_public_path__ + "static/media/Exhale Smoke.56a96fd0.png";